import {useClient} from '@adamlip/okeoke.client';
import {Slider} from '@heroui/react';
import {useEffect, useRef, useState} from 'react';
import './modifier.scss';

export default function ModifierV4Type1(props) {
	const {setCount, group} = props;
	const {getName} = useClient();
	const [toSnap, setToSnap] = useState({});
	const previouslySelected = useRef(null);
	const selected = useRef(null);
	const ref_Bar = useRef(null);

	const snapToSelected = () => {
		updateModifierSelected();
	};

	const updateModifierSelected = () => {
		if (previouslySelected.current === selected.current) return null;
		setCount(previouslySelected.current, 0);
		setCount(selected.current, 1);
		previouslySelected.current = selected.current;
	};

	const selectOptionHandler = (e) => {
		selected.current = toSnap[e].uuid;
		updateModifierSelected();
	};

	const setDefaultSelected = () => {
		let currentlySelected = null;
		let defaultValue = group?.modifiers.filter((i) => {
			if (i.count === 1) {
				currentlySelected = i.uuid;
			}
			if (i.defaultCount === 1) {
				return true;
			} else {
				return false;
			}
		})[0]?.uuid;
		selected.current = currentlySelected ? currentlySelected : defaultValue;
		previouslySelected.current = currentlySelected ? currentlySelected : defaultValue;
	};

	const prepToSnapValues = () => {
		let temp = {};
		for (let i = 0; i < group.modifiers.length; i++) {
			temp = {
				...temp,
				[i]: {
					uuid: group.modifiers[i].uuid,
					x: i === 0 ? -15 : ((ref_Bar?.current?.getBoundingClientRect().width - 30) / (group.modifiers.length - 1)) * i - 12,
				},
			};
		}
		setToSnap(temp);
	};

	useEffect(() => {
		if (ref_Bar && group) {
			prepToSnapValues();
			setDefaultSelected();
		}
		// eslint-disable-next-line
	}, [ref_Bar.current]);

	useEffect(() => {
		snapToSelected();
		// eslint-disable-next-line
	}, [toSnap]);

	return (
		<div className='w-full rounded-general flex items-center justify-center flex-col gap-2 px-2 border border-border'>
			<div className='font-bold w-full text-left'>{getName(group.name)}</div>
			<Slider
				showSteps
				step={1}
				minValue={0}
				className='w-full px-6'
				maxValue={group.modifiers?.length - 1}
				value={Object.values(toSnap).findIndex((i) => i.uuid === selected.current)}
				marks={Object.values(toSnap).map((i, index) => {
					return {
						value: index,
						label: getName(group.modifiers[index].name),
					};
				})}
				aria-label='Slider'
				onChange={(e) => {
					if (e !== Object.values(toSnap).findIndex((i) => i.uuid === selected.current)) {
						selectOptionHandler(e);
					}
				}}
				classNames={{
					thumb: ' rounded-general after:bg-secondary after:rounded-general',
					track: ' rounded-general',
					mark: 'font-bold text-center',
				}}
			/>
		</div>
	);
}
